module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/object_907_small.a54464bf.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/object_907_small.png
// module id = 1038
// module chunks = 16